
import DateFormat from '../common/dateFormat/DateFormat';

const INITIAL_STATE = {
	registro: {},
	aguardando: false,
	modoTela: 'lista',
	lista: [],
	listaGestao: [],
	listaGestaoModal: [],
	listaGestaoAnalise: [],
	listaAnalise: [],
	listaTipo: [],
	listaMotorista: [],
	listaGravidade: [],
	listaLocal: [],
	listaResponsabilidade: [],
	listaTipoCusto: [],
	listaUsuario: [],
	listaStatus: [],
	listaStatusGestao: [],
	listaAcao: [],
	listaHistorico: [],
	listaCategoria: [],
	listaOperacao: [],
	listaClasse: [],
	listaTratativas: [],
	listaComentarioGestao: [],
	listaTipoOcorrrencia: [{ id: 'PRM', valor: 'PRM' }, { id: 'DOC', valor: 'DOC' }, { id: 'VPR', valor: 'VPR' }, { id: 'AVULSA', valor: 'AVULSA' }],
	filtro: {
		data_inicial: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAnterior(30)),
		data_final: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual()),
		tipo_periodo: 'datahora_ocorrencia'
	},
	filtroPrincipal: {
		data_inicial: DateFormat.getDataAnterior(30),
		data_final: DateFormat.getDataAtual()
	},
	filtroGestao: {
		data_inicial: DateFormat.getDataAnterior(30),
		data_final: DateFormat.getDataAtual()
	},
	filtroAnalise: {
		data_inicial: DateFormat.getDataAnterior(60),
		data_final: DateFormat.getDataAtual()
	}
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'OCORRENCIA_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'OCORRENCIA_FILTRO':
            return { ...state,
				filtro: action.payload.filtro
			};

		case 'OCORRENCIA_PRINCIPAL_FILTRO':
            return { ...state,
				filtroPrincipal: action.payload.filtro
			};

		case 'OCORRENCIA_GESTAO_FILTRO':
            return { ...state,
				filtroGestao: action.payload.filtro
			};

		case 'OCORRENCIA_ANALISE_FILTRO':
            return { ...state,
				filtroAnalise: action.payload.filtro
			};

		case 'OCORRENCIA_SET_AGUARDANDO':
            return { ...state,
				aguardando: action.payload
			};

        case 'OCORRENCIA_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

		case 'OCORRENCIA_GESTAO_LISTADO':
            return {
				...state,
				listaGestao: action.payload.data
			};
		
		case 'OCORRENCIA_GESTAO_MODAL_LISTADO':
            return {
				...state,
				listaGestaoModal: action.payload.data
			};

		case 'OCORRENCIA_GESTAO_ANALISE_LISTADO':
			return {
				...state,
				listaGestaoAnalise: action.payload.data
			};

		case 'OCORRENCIA_ANALISE_LISTADO':
			return {
				...state,
				listaAnalise: action.payload.data
			};

		case 'OCORRENCIA_HISTORICO_LISTADO':
            return {
				...state,
				listaHistorico: action.payload.data
			};

        case 'OCORRENCIA_TIPO_SELECT_LISTADO':
			return {
				...state,
				listaTipo: action.payload.data
			};

        case 'OCORRENCIA_MOTORISTA_SELECT_LISTADO':
			return {
				...state,
				listaMotorista: action.payload.data
			};

        case 'OCORRENCIA_GRAVIDADE_SELECT_LISTADO':
			return {
				...state,
				listaGravidade: action.payload.data
			};

        case 'OCORRENCIA_LOCAL_SELECT_LISTADO':
			return {
				...state,
				listaLocal: action.payload.data
			};

        case 'OCORRENCIA_RESPONSABILIDADE_SELECT_LISTADO':
			return {
				...state,
				listaResponsabilidade: action.payload.data
			};

        case 'OCORRENCIA_TIPO_CUSTO_SELECT_LISTADO':
			return {
				...state,
				listaTipoCusto: action.payload.data
			};

		case 'OCORRENCIA_STATUS_SELECT_LISTADO':
			return {
				...state,
				listaStatus: action.payload.data
			};

		case 'OCORRENCIA_STATUS_GESTAO_SELECT_LISTADO':
			return {
				...state,
				listaStatusGestao: action.payload.data
			};

		case 'OCORRENCIA_ACAO_SELECT_LISTADO':
			return {
				...state,
				listaAcao: action.payload.data
			};

		case 'OCORRENCIA_USUARIO_SELECT_LISTADO':
			return {
				...state,
				listaUsuario: action.payload.data
			};

		case 'OCORRENCIA_CATEGORIA_SELECT_LISTADO':
			return {
				...state,
				listaCategoria: action.payload.data
			};
		
		case 'OCORRENCIA_OPERACAO_SELECT_LISTADO':
			return {
				...state,
				listaOperacao: action.payload.data
			};
	
		case 'OCORRENCIA_CLASSE_SELECT_LISTADO':
			return {
				...state,
				listaClasse: action.payload.data
			};

		case 'OCORRENCIA_TRATATIVA_LISTADO':
			return {
				...state,
				listaTratativas: action.payload.data
			};

		case 'OCORRENCIA_COMENTARIO_GESTAO_LISTADO':
			return {
				...state,
				listaComentarioGestao: action.payload.data
			};

        default:
            return state;
    }
}
